/* eslint-disable no-use-before-define */
import React from 'react'
import { getId } from '../../twd'
import {
    CartesianGrid,
    ResponsiveContainer,
    Scatter,
    ScatterChart,
    XAxis,
    YAxis,
} from 'recharts'
import { ChartTooltip } from './chart-tooltip'
import { getIcon, DealerToDealerIcon, CustomerSellIcon, CustomerBuyIcon } from './chart-shapes'
import { formatXAxisTicks, formatYAxisTicks } from './chart-format'

export const Chart = ({context}) => {

    const [showCustomerBuys, setShowCustomerBuys] = React.useState(true)
    const [showCustomerSells, setShowCustomerSells] = React.useState(true)
    const [showDealerToDealers, setShowDealerToDealers] = React.useState(true)

    const xDomain = context.chartXDomain({showCustomerBuys, showCustomerSells, showDealerToDealers})

    return <React.Fragment>

        <div className="row">
        <div className="col-md-12">
            <CheckboxSelector value={showCustomerBuys} setValue={setShowCustomerBuys} label="Customer Buy" />
            <CheckboxSelector value={showCustomerSells} setValue={setShowCustomerSells} label="Customer Sell" />
            <CheckboxSelector value={showDealerToDealers} setValue={setShowDealerToDealers} label="Dealer to Dealer" />
        </div>
        </div>

        <div className="row vertical-offset-xs">
        <div className="col-md-12">
        <ResponsiveContainer width="100%" height={240}>
        <ScatterChart
            margin={{
                top: 5, right: 40, left: 0, bottom: 5,
            }}
        >
        <CartesianGrid vertical={false} />

        <XAxis 
            dataKey="x"
            domain={xDomain}
            ticks={context.chartXTicks(xDomain)}
            interval="preserveStartEnd"
            type="number"
            scale="time"
            tickFormatter={(a) => formatXAxisTicks(a, context.filterByDate, showCustomerBuys || showCustomerSells || showDealerToDealers)}
            padding={{left: 10, right: 10}}
            />

        <YAxis 
            dataKey="y"
            domain={context.chartYDomain({showCustomerBuys, showCustomerSells, showDealerToDealers})}
            width={5}
            tickFormatter={(a) => formatYAxisTicks(a, context.showDataAs)}
            scale='linear'
            axisLine={false}
            orientation='right' />   

        {showCustomerBuys && <Scatter name="Customer Buy" {...ChartTooltip} shape={(p) => <CustomerBuyIcon {...p} />} data={context.customerBuys()}/>}
        
        {showCustomerSells && <Scatter name="Customer Sell" {...ChartTooltip} shape={(p) => <CustomerSellIcon {...p} />} data={context.customerSells()} />}

        {showDealerToDealers && <Scatter name="Dealer to Dealer" {...ChartTooltip} shape={(p) => <DealerToDealerIcon {...p} />} data={context.dealerToDealers()} />}
        
        </ScatterChart>
        </ResponsiveContainer>
        </div>
        </div>
    </React.Fragment>
}

const CheckboxSelector = ({value, setValue, label}) => {
    const id = getId('trader-history-checkbox-selector')
    return <React.Fragment>
    <div className="checkbox" style={{display: 'inline-block'}}>
    <input 
        type="checkbox" 
        id={id}
        checked={value} 
        onChange={(e) => { 
            console.log('changed', e.target.checked)
            setValue(e.target.checked)
        }} 
    /> 
    
    <label htmlFor={id} style={{marginRight: '10px'}}>
        <span style={{marginRight: '5px'}}>{getIcon(label)}</span> {label}
    </label>
    </div>
    </React.Fragment>
}




// WEBPACK FOOTER //
// ./src/trade-history/history/chart.js